import { T } from '@tf/utils';
import { useParams } from 'react-router-dom';

export const usePaymentAssessmentParams = () => {
	const { paymentId, assessmentId, screeningId } = useParams<{
		paymentId: string;
		assessmentId: string;
		screeningId: string;
	}>();

	T.assertNotNullish(paymentId, 'paymentId is missing');
	T.assertNotNullish(assessmentId, 'assessmentId is missing');

	return { paymentObjectName: paymentId, assessmentObjectName: assessmentId, screeningId };
};
